import { CALL_API } from "admin/middlewares/api";

export const USER_APPLICATION_LIST_CHANGE_PAGE =
  "USER_APPLICATION_LIST_CHANGE_PAGE";

export function change_application_list_page(page) {
  return {
    type: USER_APPLICATION_LIST_CHANGE_PAGE,
    page,
  };
}

export const USER_APPLICATION_LIST_CHANGE_FILTER =
  "USER_APPLICATION_LIST_CHANGE_FILTER";

export function change_application_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: USER_APPLICATION_LIST_CHANGE_FILTER,
    filter,
  };
}

export const USER_APPLICATION_APPROVE_REQUEST =
  "USER_APPLICATION_APPROVE_REQUEST";
export const USER_APPLICATION_APPROVE_SUCCESS =
  "USER_APPLICATION_APPROVE_SUCCESS";
export const USER_APPLICATION_APPROVE_ERROR = "USER_APPLICATION_APPROVE_ERROR";

export function approve_application(applicationId, offerId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/approve",
      method: "POST",
      data: { ApplicationId: applicationId, OfferId: offerId },
      authenticatedRequest: true,
      types: [
        USER_APPLICATION_APPROVE_REQUEST,
        USER_APPLICATION_APPROVE_SUCCESS,
        USER_APPLICATION_APPROVE_ERROR,
      ],
    },
  };
}

export const USER_APPLICATION_REJECT_REQUEST =
  "USER_APPLICATION_REJECT_REQUEST";
export const USER_APPLICATION_REJECT_SUCCESS =
  "USER_APPLICATION_REJECT_SUCCESS";
export const USER_APPLICATION_REJECT_ERROR = "USER_APPLICATION_REJECT_ERROR";

export function reject_application(applicationId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/reject",
      method: "POST",
      data: { ApplicationId: applicationId },
      authenticatedRequest: true,
      types: [
        USER_APPLICATION_REJECT_REQUEST,
        USER_APPLICATION_REJECT_SUCCESS,
        USER_APPLICATION_REJECT_ERROR,
      ],
    },
  };
}

export const USER_APPLICATION_NOMINAL_OFFER_REQUEST =
  "USER_APPLICATION_NOMINAL_OFFER_REQUEST";
export const USER_APPLICATION_NOMINAL_OFFER_SUCCESS =
  "USER_APPLICATION_NOMINAL_OFFER_SUCCESS";
export const USER_APPLICATION_NOMINAL_OFFER_ERROR =
  "USER_APPLICATION_NOMINAL_OFFER_ERROR";

export function set_nominal_offer(postData) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/offer/nominalbased",
      method: "POST",
      data: postData,
      authenticatedRequest: true,
      types: [
        USER_APPLICATION_NOMINAL_OFFER_REQUEST,
        USER_APPLICATION_NOMINAL_OFFER_SUCCESS,
        USER_APPLICATION_NOMINAL_OFFER_ERROR,
      ],
    },
  };
}

export const USER_APPLICATION_RISK_OFFER_REQUEST =
  "USER_APPLICATION_RISK_OFFER_REQUEST";
export const USER_APPLICATION_RISK_OFFER_SUCCESS =
  "USER_APPLICATION_RISK_OFFER_SUCCESS";
export const USER_APPLICATION_RISK_OFFER_ERROR =
  "USER_APPLICATION_RISK_OFFER_ERROR";

export function set_risk_offer(postData) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/offer/riskbased",
      method: "POST",
      data: postData,
      authenticatedRequest: true,
      types: [
        USER_APPLICATION_RISK_OFFER_REQUEST,
        USER_APPLICATION_RISK_OFFER_SUCCESS,
        USER_APPLICATION_RISK_OFFER_ERROR,
      ],
    },
  };
}

export const USER_EXPANDED_DATA_BISNODE_REQUEST =
  "USER_EXPANDED_DATA_BISNODE_REQUEST";
export const USER_EXPANDED_DATA_BISNODE_SUCCESS =
  "USER_EXPANDED_DATA_BISNODE_SUCCESS";
export const USER_EXPANDED_DATA_BISNODE_ERROR =
  "USER_EXPANDED_DATA_BISNODE_ERROR";

export function get_row_additional_data_bisnode(accountId, Id) {
  let endpoint = "/api/admin/creditreport/creditsafe?accountId=" + accountId;

  return {
    [CALL_API]: {
      endpoint: endpoint,
      authenticatedRequest: true,
      data: { accountId },
      correlation: { Id },
      types: [
        USER_EXPANDED_DATA_BISNODE_REQUEST,
        USER_EXPANDED_DATA_BISNODE_SUCCESS,
        USER_EXPANDED_DATA_BISNODE_ERROR,
      ],
    },
  };
}

//ToDo: remove when we have implemented termination
export const USER_SWAP_APPLICATION_DATA = "USER_SWAP_APPLICATION_DATA";

export function swap_data() {
  return {
    type: USER_SWAP_APPLICATION_DATA,
  };
}
